import { take, switchMap, of, map, Subject, Observable } from "rxjs";
import {
  FetchRefundRequestsDocument,
  RefundRequest,
  SetRefundRequestStatusDocument,
} from "../generated-graphql/graphql";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import {
  DataService,
  SharedModule,
  TypedBaseListComponent,
  ModalService,
  OrderDetailFragment,
  NotificationService,
  GetOrderQuery,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit } from "@angular/core";
import {
  CustomerNameFromOrderIdPipe,
  OrderNumberPipe,
  StatusColorPipe,
} from "../Pipe";
import { RefundOrderDialogComponent } from "@bb-vendure/admin-ui/order";
import ModalRefundDetailComponent from "../request-refund-dialog/modal.component";

@Component({
  selector: "request-refund-table",
  standalone: true,
  imports: [
    SharedModule,
    CustomerNameFromOrderIdPipe,
    OrderNumberPipe,
    StatusColorPipe,
  ],
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export default class RequestRefundFromCustomerTableComponent
  extends TypedBaseListComponent<
    typeof FetchRefundRequestsDocument,
    "refundRequests"
  >
  implements OnInit
{
  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private notiService: NotificationService
  ) {
    super();
    super.configure({
      document: FetchRefundRequestsDocument,
      getItems: (data) => data.refundRequests,
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            type: {
              eq: "Customer",
            },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }
  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addFilters([
      {
        filterField: "createdAt",
        label: "Creation Date",
        type: { kind: "dateRange" },
        name: "Creation Date",
      },
      {
        filterField: "status",
        label: "Status",
        name: "status",
        type: {
          kind: "select",
          options: [
            { value: "new", label: "New" },
            { value: "rejected", label: "Rejected" },
            { value: "approved", label: "Approved" },
            { value: "refunded", label: "Refunded" },
          ],
        },
      },
    ])
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .connectToRoute(this.route);

  getQuantity(refundReq: any): number {
    return refundReq.lines.reduce((sum, line) => sum + line.quantity, 0);
  }

  viewDetail(refundReq: any) {
    this.modalService
      .fromComponent(ModalRefundDetailComponent, {
        size: "xl",
        closable: true,
        locals: {
          refundReq: refundReq,
          currencyCode: refundReq.order.currencyCode,
        },
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          switch (result?.status) {
            case "CLOSE":
              break;
            case "REFUND_ORDER":
              // this.refundOrder(result.order!, result.id, refundReq);
              break;
            default:
              this.setStatus(result.id, result.status.toLowerCase());
              break;
          }
        }
      });
  }

  setStatus(id: string, status: string) {
    this.dataService
      .mutate(SetRefundRequestStatusDocument, {
        input: {
          id,
          status,
        },
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result.updateRefundRequest.__typename === "RefundRequest") {
          this.notiService.success("Refund Request Updated");
        }
        this.refresh();
      });
  }

  refundOrder(order: OrderDetailFragment, refundId: string, refundReq?: any) {
    console.log(refundReq);
    const { args } = refundReq;

    if (args.refunds.length) {
      this.dataService.order
        .refundOrder(args.refunds[0])
        .subscribe(({ refundOrder }) => {
          if (refundOrder) {
            switch (refundOrder.__typename) {
              case "Refund":
                if (refundOrder.state === "Failed") {
                  this.notiService.error(_("order.refund-order-failed"));
                } else {
                  this.notiService.success(_("order.refund-order-success"));
                  this.setStatus(refundReq.id, "refunded");
                  if (args.cancel.lines?.length) {
                    this.dataService.order
                      .cancelOrder(args.cancel)
                      .subscribe(({ cancelOrder }) => {
                        if (cancelOrder) {
                          switch (cancelOrder.__typename) {
                            case "Order":
                              this.notiService.success(
                                _("order.cancelled-order-success")
                              );
                              break;
                            case "CancelActiveOrderError":
                            case "QuantityTooGreatError":
                            case "MultipleOrderError":
                            case "OrderStateTransitionError":
                            case "EmptyOrderLineSelectionError":
                              this.notiService.error(cancelOrder.message);
                              break;
                          }
                        }
                      });
                  }
                }
                break;
              case "AlreadyRefundedError":
              case "NothingToRefundError":
              case "PaymentOrderMismatchError":
              case "RefundOrderStateError":
              case "RefundStateTransitionError":
                this.notiService.error(refundOrder.message);
                break;
            }
          }
        });
    }
  }
  //   this.modalService
  //     .fromComponent(RefundOrderDialogComponent, {
  //       size: "xl",
  //       closable: true,
  //       locals: {
  //         order,
  //       },
  //     })
  //     .pipe(
  //       switchMap((input) => {
  //         if (!input) {
  //           return of(undefined);
  //         }

  //         if (input.cancel.lines?.length) {
  //           return this.dataService.order.cancelOrder(input.cancel).pipe(
  //             map((res) => {
  //               const result = res.cancelOrder;
  //               switch (result.__typename) {
  //                 case "Order":
  //                   this.notiService.success(
  //                     _("order.cancelled-order-success")
  //                   );
  //                   this.setStatus(refundId, "refunded");
  //                   return input;
  //                 case "CancelActiveOrderError":
  //                 case "QuantityTooGreatError":
  //                 case "MultipleOrderError":
  //                 case "OrderStateTransitionError":
  //                 case "EmptyOrderLineSelectionError":
  //                   this.notiService.error(result.message);
  //                   return undefined;
  //               }
  //             })
  //           );
  //         } else {
  //           return [input];
  //         }
  //       }),
  //       switchMap((input) => {
  //         if (!input) {
  //           return of(undefined);
  //         }
  //         if (input.refunds.length) {
  //           // return this.dataService.order
  //           //   .refundOrder(input.refund)
  //           //   .pipe(map((res) => res.refundOrder));
  //           return this.dataService.order.refundOrder(input.refunds[0]).pipe(
  //             map((res) => res.refundOrder)
  //           );
  //         } else {
  //           return [undefined];
  //         }
  //       })
  //     )
  //     .subscribe((result) => {
  //       if (result) {
  //         switch (result.__typename) {
  //           case "Refund":
  //             if (result.state === "Failed") {
  //               this.notiService.error(_("order.refund-order-failed"));
  //             } else {
  //               this.notiService.success(_("order.refund-order-success"));
  //               this.setStatus(refundId, "refunded");
  //             }
  //             break;
  //           case "AlreadyRefundedError":
  //           case "NothingToRefundError":
  //           case "PaymentOrderMismatchError":
  //           case "RefundOrderStateError":
  //           case "RefundStateTransitionError":
  //             this.notiService.error(result.message);
  //             break;
  //         }
  //       }
  //     });
  // }
}
